var map = {
	"./add_annoucment.svg": 21434,
	"./add_annoucment_hover.svg": 80385,
	"./add_meeting.svg": 98849,
	"./add_meeting_hover.svg": 28994,
	"./archive-solid.svg": 3994,
	"./arrow.svg": 92353,
	"./box-archive.svg": 74699,
	"./calendar-days.svg": 5267,
	"./callendar-gray.svg": 11660,
	"./callendar.svg": 79112,
	"./comment-sms.svg": 79377,
	"./eye-slash.svg": 6369,
	"./eye.svg": 26373,
	"./globe.svg": 68465,
	"./news.svg": 88283,
	"./send_e-mail.svg": 20732,
	"./send_e-mail_hover.svg": 32635,
	"./send_sms.svg": 37586,
	"./send_sms_hover.svg": 42473,
	"./time.svg": 4901,
	"./warning.svg": 56910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68898;